import styled from "@emotion/styled";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH } from "constants/vp-sizes";
import DesktopHeaderConstants from "segments/desktop/header/layouts/components/basic-header/constants";

const HEADER_LOGO_HORIZONTAL_PADDING = `${DesktopHeaderConstants.HEADER_CONTENT_HORIZONTAL_PADDING}px`;

export const StyledSideBySideHubspotFormComponent = styled.div`
  max-width: ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px;
  margin: auto;
  &.align-to-logo {
    padding-left: ${HEADER_LOGO_HORIZONTAL_PADDING};
    padding-right: ${HEADER_LOGO_HORIZONTAL_PADDING};
  }
  .side-by-side-asset-and-paragraph {
    display: flex;
    flex-direction: column;
  }
`;
